var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bancos-clientes-screen"},[_c('perseo-menu-mantenimiento',{attrs:{"config":_vm.menuConfig},on:{"actualizar":_vm.handleActualizar}}),_c('bancos-clientes-listado',{ref:"listadoBancosClientes"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }